<template>
	<v-form ref="form" v-model="isFormValid" lazy-validation>
		<modal
			:exibir="exibir"
			:titulo="titulo"
			:max-width="modalOptions.largura"
			:is-confirmar-desabilitado="!isFormValid"
			:custom-actions="false"
			nome-botao-confirmar="Salvar"
			:acao-confirmar="salvarEdicaoRespostaOcorrencia"
			@close="fecharModal"
			:acao-cancelar="fecharModal"
			:is-confirmar-visivel="isConfirmarVisivel()"
		>
			<template #body>
				<v-row class="mt-4">
					<v-col cols="4">
						<label-personalizado nome-campo="Responsável" class="mb-2"></label-personalizado>
						<p>{{ ocorrencia.autor }}</p>
					</v-col>
					<v-col cols="4">
						<label-personalizado nome-campo="Última Atualização" class="mb-2"></label-personalizado>
						<p>
							{{
								ocorrencia.dataAlteracao
									? ocorrencia.dataAlteracao
									: ocorrencia.dataCadastro | formatDataHourMinuteFilter
							}}
						</p>
					</v-col>
					<v-col cols="4">
						<label-personalizado nome-campo="Atividade" class="mb-2"></label-personalizado>
						<p>{{ ocorrencia.atividade }}</p>
					</v-col>
				</v-row>

				<v-row class="mt-1 mb-2">
					<v-col cols="12">
						<label-personalizado nome-campo="Descrição" class="mb-2"></label-personalizado>
						<v-textarea
							readonly
							disabled
							ref="descricao"
							:value="ocorrencia.descricao"
							:rows="4"
							counter="4000"
							class="ma-0 py-0"
						></v-textarea>
					</v-col>
				</v-row>

				<v-row class="ma-0 mt-4">
					<v-col cols="12" class="px-0">
						<label-personalizado nome-campo="Resposta" obrigatorioPorPadrao></label-personalizado>
						<v-textarea
							v-model="respostaLocal.descricao"
							data-test="v-text-field.descricao-responder-ocorrencia"
							name="Responder Ocorrencia"
							rows="4"
							:counter="4000"
							class="ma-0 py-0"
							placeholder="Informe a descrição da resposta"
							:rules="regras"
							@input="corrigirTexto"
						></v-textarea>
					</v-col>
				</v-row>
			</template>
		</modal>
	</v-form>
</template>

<script>
import Modal from '@/views/components/Modal.vue'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'

export default {
	name: 'modal-editar-resposta-ocorrencia',
	components: {
		Modal,
		LabelPersonalizado,
	},
	mixins: [validacaoFormulario],
	props: {
		exibir: {
			type: Boolean,
			default: false,
		},
		titulo: {
			type: String,
			required: true,
		},
		ocorrencia: {
			type: Object,
			required: true,
		},
		resposta: {
			type: Object,
			default: () => ({ id: null, descricao: '' }),
		},
	},
	emits: ['fechar-modal', 'editar-resposta'],
	data() {
		return {
			isFormValid: true,
			modalOptions: {
				largura: '1076',
				altura: '1600',
			},
			respostaLocal: { ...this.resposta },
			regras: [
				(value) => this.regraObrigatoriedade(value, 'A resposta é obrigatória.'),
				(value) =>
					this.regraDeTamanhoMaximoString(
						value,
						4000,
						'O campo de resposta deve ser igual ou menor que 4000 caracteres!',
					),
			],
		}
	},
	computed: {
		ehEdicaoRespostaOcorrencia() {
			return this.respostaLocal.id !== null
		},
	},
	watch: {
		resposta(newVal) {
			this.respostaLocal = { ...newVal }
		},
	},
	created() {},
	methods: {
		fecharModal() {
			this.$emit('fechar-modal')
		},
		async salvarEdicaoRespostaOcorrencia() {
			if (this.ehEdicaoRespostaOcorrencia && this.respostaEstaDiferente()) {
				const payload = {
					idResposta: this.respostaLocal.id,
					resposta: this.respostaLocal.descricao,
				}
				this.$emit('editar-resposta', payload)
			}
		},
		isConfirmarVisivel() {
			return true
		},
		corrigirTexto() {
			if (this.respostaLocal.resposta) {
				this.respostaLocal.resposta = this.respostaLocal.resposta.trim()
			}
		},
		respostaEstaDiferente() {
			if (!!this.respostaLocal.descricao && this.resposta.descricao !== this.respostaLocal.descricao.trim())
				return true

			this.mostrarNotificacaoWarning('Campo resposta não foi alterado!')
			return false
		},
	},
}
</script>

<style lang="stylus" scoped></style>
